// AI-generated code
import { type Index } from '@synqo/frontend-component-library';
import { createContext, useContext } from 'react';

export interface NotificationsCountContextProps {
    stagedOrders: number;
}

const defaultValue: NotificationsCountContextProps = {
    stagedOrders: 0,
};

export const NotificationsCountContext = createContext<NotificationsCountContextProps>(defaultValue);

/**
 * Returns the notifications count state.
 */
export function useNotificationsCount(): NotificationsCountContextProps;

/**
 * Returns the specific notifications count value type (e.g., number) when a key is provided.
 * @param key - The property name to retrieve.
 */
export function useNotificationsCount(key: Index<NotificationsCountContextProps>): number;

/**
 * Implementation
 */
export function useNotificationsCount(
    key?: keyof NotificationsCountContextProps,
): NotificationsCountContextProps | number {
    const ctx = useContext(NotificationsCountContext);

    if (key) {
        return ctx[key];
    }

    return ctx;
}
